import React from "react";
import { usePermissionTabs } from "../../hooks/usePermissionTabs";
import { PermissionTabManager } from "../../components/PermissionTabManager";
import InvoiceTab from "./_components/InvoiceTab";
import LinehualTab from "./_components/LinehualTab";
import { useLanguage } from "../../context/LanguageContext";

const ALL_TABS = [
  {
    key: "Invoices",
    label: "Invoices",
    component: <InvoiceTab />,
    modules: ["invoices"],
    operation: "read" as const,
  },
  {
    key: "Linehaul",
    label: "Linehaul",
    component: <LinehualTab />,
    modules: ["linehaul_invoices"],
    operation: "read" as const,
  },
];

const InvoiceManagement: React.FC = () => {
  const { t } = useLanguage();
  const [mainHeaderButtons, setMainHeaderButtons] = React.useState<React.ReactNode>(null);
  const result = usePermissionTabs({ tabs: ALL_TABS, param: "tab" });

  const clonedContent =
    result.content && React.isValidElement(result.content)
      ? React.cloneElement(result.content as React.ReactElement, {
          setHeaderButtons: setMainHeaderButtons,
        } as any)
      : result.content;

  return (
    <PermissionTabManager
      visibleTabs={result.visibleTabs}
      activeLabel={result.activeLabel ?? ""}
      content={clonedContent}
      isLoading={result.isLoading}
      error={result.error}
      handleChange={result.handleChange}
      className="p-4 pt-0 space-y-4"
      headerButtons={mainHeaderButtons}
    />
  );
};

export default InvoiceManagement;
